import * as React from 'react';

export const LogoSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={61}
      height={24}
      fill='none'
    >
      <g>
        <path
          fill='#1E2538'
          d='M11.529 15.24c1.52-2.633-.904-4.381-.987-4.464-.061.062-.883.946-.986 2.14-1.048-1.132-2.672-1.05-2.774-1.03 0 .124-.185 2.962 2.61 3.559-1.13 1.234-3.453 3.372-6.494 4.236-.596.165-1.85.391-2.59.206-.657-.165-.061 2.591-.061 2.591s7.583-1.13 11.693-.473c2.158.35 5.384 1.954 5.384 1.954-.76-2.88-1.85-5.388-2.98-7.075a55.573 55.573 0 0 0-2.815-1.645Z'
        />
        <path
          fill='#FCC55E'
          d='M11.077 18.88a1.952 1.952 0 1 1-3.905 0c0-1.07.863-1.954 1.952-1.954 1.09.02 1.953.884 1.953 1.953Z'
        />
        <path
          fill='url(#b)'
          d='M56.165 16.76a16.849 16.849 0 0 0-.802-.678c-1.89 3.188-4.603 6.211-6.247 7.897 0 0 4.541-3.516 7.049-7.218Z'
        />
        <path
          fill='url(#c)'
          d='M41.163 1.213c-.185 3.497-1.151 11.476-5.816 22.766 0 0 7.768-14.395 7.747-21.964a17.41 17.41 0 0 0-1.931-.802Z'
        />
        <path
          fill='url(#d)'
          d='M23.304 23.98h1.583C26.18 11.907 19.05 5.8 19.05 5.8c1.685 3.228 4.44 9.83 4.254 18.18Z'
        />
        <path
          fill='url(#e)'
          d='M10.316 18.2c-.082-.123-.493-.41-.596-.493-.904.02-1.459.144-2.034.967-.288.946.308 2.015 1.233 2.159 1.397.185 2.404-1.378 1.397-2.632Z'
          opacity={0.42}
        />
        <path
          fill='#fff'
          d='M10.501 18.88a1.355 1.355 0 1 1-2.712 0c0-.762.616-1.358 1.356-1.358.74 0 1.356.617 1.356 1.357Z'
        />
        <path
          fill='url(#f)'
          d='M10.399 18.776a1.356 1.356 0 1 1-2.713 0c0-.76.616-1.357 1.356-1.357.74 0 1.357.617 1.357 1.357Z'
        />
        <path
          fill='#000'
          d='M9.289 18.612c0 .37-.308.679-.678.679a.684.684 0 0 1-.679-.68c0-.37.309-.678.679-.678.37 0 .678.309.678.679Z'
        />
        <path
          fill='#fff'
          d='M9.124 18.427c0 .123-.082.226-.205.226-.103 0-.206-.103-.206-.226 0-.124.083-.226.206-.226.123 0 .205.102.205.226Z'
        />
        <path
          fill='url(#g)'
          d='M41.163 1.213c-.185 3.497-1.151 11.476-5.816 22.766h3.637c2.096-4.03 7.193-14.334 7.563-19.99a22.254 22.254 0 0 0-5.384-2.776Z'
        />
        <path
          fill='url(#h)'
          d='M55.363 16.082c-1.89 3.188-4.603 6.211-6.247 7.897h4.583c.575-1.316 2.322-5.038 3.431-6.272-1.048-.925-.267-.411-1.767-1.625Z'
        />
        <path
          fill='#1E2538'
          d='M53.596 11.908c-.699 1.912-1.85 3.928-3.124 5.799-.288 4.195-1.336 6.252-1.336 6.252 1.295-1.337 3.268-3.496 4.953-5.923a50.66 50.66 0 0 0-.493-6.129Z'
        />
        <path
          fill='url(#i)'
          d='M19.07 5.8c1.686 3.228 4.44 9.83 4.234 18.18h3.515c.637-6.52.678-16.762-1.706-22.13A22.703 22.703 0 0 0 19.07 5.8Z'
        />
        <path
          fill='#1E2538'
          d='M30.476 10.632c-2.26-5.47-5.343-8.781-5.343-8.781 1.5 3.414 2.035 8.76 2.055 13.902C29.08 20.175 29.1 23.98 29.1 23.98c1.212-5.1 1.5-9.604 1.376-13.347Z'
        />
        <path
          fill='url(#j)'
          d='M12.844 15.157c1.583 1.275 3.391 4.668 4.48 8.822h3.7c-.576-3.455-2.015-9.419-5.426-14.21a22.973 22.973 0 0 0-2.754 5.388Z'
        />
        <path
          fill='#1E2538'
          d='M22.585 15.856c-3.268-3.99-6.987-6.087-6.987-6.087 2.014 2.838 3.35 6.108 4.213 9.007 2.569 2.448 3.493 5.203 3.493 5.203a37.236 37.236 0 0 0-.719-8.123Z'
        />
        <path
          fill='url(#k)'
          d='m57.953 22.293-1.645-1.46 4.378-2.365-2.733 3.825Z'
        />
        <path
          fill='#1E2538'
          d='M57.13 17.707c-.37.39-.78 1.07-1.233 1.83l.39 1.317 1.46-.782-.617-2.365ZM31.155 24c-.083-2.18-1.624-3.907-3.494-3.907-1.89 0-3.411 1.727-3.494 3.907h6.988Z'
        />
        <path
          fill='url(#l)'
          d='M36.6.165a21.533 21.533 0 0 0-7.706.432c1.09 3.598 2.898 12.071.205 23.382h3.617C33.56 21.121 37.546 7.054 36.6.165Z'
        />
        <path
          fill='#1E2538'
          d='M39.046 13.244C38.409 5.635 36.6.164 36.6.164c.535 3.867-.493 9.995-1.644 15.116.576 4.75.39 8.7.39 8.7 1.666-4.01 2.858-7.61 3.7-10.736ZM47.287 13.182c.35-6.107-.72-9.192-.72-9.192-.226 3.414-2.178 8.534-4.15 12.935a93.015 93.015 0 0 1-1.131 6.972h.041c2.404-3.29 4.439-7.28 5.96-10.714Z'
        />
        <path
          fill='#1E2538'
          d='M44.656 23.98c-.082-2.078-1.746-3.744-3.781-3.744s-3.679 1.666-3.781 3.743h7.562Z'
        />
        <path
          fill='url(#m)'
          d='M49.815 6.766c-1.192 3.373-4.275 11.414-8.55 17.213h4.296c2.301-2.611 6.411-7.63 8.035-12.072a23.374 23.374 0 0 0-3.781-5.141Z'
        />
      </g>
      <defs>
        <linearGradient
          id='b'
          x1={49.959}
          x2={56.896}
          y1={24.334}
          y2={14.081}
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset={0.121}
            stopColor='#0006C0'
          />
          <stop
            offset={0.834}
            stopColor='#fff'
          />
        </linearGradient>
        <linearGradient
          id='c'
          x1={33.907}
          x2={42.791}
          y1={21.728}
          y2={3.272}
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset={0.121}
            stopColor='#0006C0'
          />
          <stop
            offset={0.993}
            stopColor='#fff'
          />
        </linearGradient>
        <linearGradient
          id='d'
          x1={21.476}
          x2={22.475}
          y1={25.419}
          y2={5.351}
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset={0.121}
            stopColor='#0006C0'
          />
          <stop
            offset={0.993}
            stopColor='#fff'
          />
        </linearGradient>
        <linearGradient
          id='e'
          x1={10.059}
          x2={8.389}
          y1={17.515}
          y2={20.72}
          gradientUnits='userSpaceOnUse'
        >
          <stop
            offset={0.091}
            stopColor='#0FF'
          />
          <stop
            offset={0.099}
            stopColor='#02FCFB'
          />
          <stop
            offset={0.247}
            stopColor='#23C4BA'
          />
          <stop
            offset={0.393}
            stopColor='#409381'
          />
          <stop
            offset={0.532}
            stopColor='#576C53'
          />
          <stop
            offset={0.665}
            stopColor='#694D2F'
          />
          <stop
            offset={0.788}
            stopColor='#763715'
          />
          <stop
            offset={0.9}
            stopColor='#7E2A05'
          />
          <stop
            offset={0.988}
            stopColor='#812500'
          />
        </linearGradient>
        <linearGradient
          id='f'
          x1={7.673}
          x2={10.399}
          y1={18.782}
          y2={18.782}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#B3B3B3' />
          <stop
            offset={0.921}
            stopColor='#fff'
          />
        </linearGradient>
        <linearGradient
          id='g'
          x1={8.878}
          x2={63.547}
          y1={6.408}
          y2={17.909}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#812500' />
          <stop
            offset={0.158}
            stopColor='#B30056'
          />
          <stop
            offset={0.297}
            stopColor='#FF5945'
          />
          <stop
            offset={0.406}
            stopColor='#FFBD2D'
          />
          <stop
            offset={0.533}
            stopColor='#F5FF43'
          />
          <stop
            offset={0.618}
            stopColor='#82E82D'
          />
          <stop
            offset={0.733}
            stopColor='#00C79F'
          />
          <stop
            offset={0.83}
            stopColor='#00CCEC'
          />
          <stop
            offset={0.958}
            stopColor='#69DBFF'
          />
        </linearGradient>
        <linearGradient
          id='h'
          x1={7.975}
          x2={62.643}
          y1={10.703}
          y2={22.203}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#812500' />
          <stop
            offset={0.158}
            stopColor='#B30056'
          />
          <stop
            offset={0.297}
            stopColor='#FF5945'
          />
          <stop
            offset={0.406}
            stopColor='#FFBD2D'
          />
          <stop
            offset={0.533}
            stopColor='#F5FF43'
          />
          <stop
            offset={0.618}
            stopColor='#82E82D'
          />
          <stop
            offset={0.733}
            stopColor='#00C79F'
          />
          <stop
            offset={0.83}
            stopColor='#00CCEC'
          />
          <stop
            offset={0.958}
            stopColor='#69DBFF'
          />
        </linearGradient>
        <linearGradient
          id='i'
          x1={8.219}
          x2={62.887}
          y1={9.543}
          y2={21.044}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#812500' />
          <stop
            offset={0.158}
            stopColor='#B30056'
          />
          <stop
            offset={0.297}
            stopColor='#FF5945'
          />
          <stop
            offset={0.406}
            stopColor='#FFBD2D'
          />
          <stop
            offset={0.533}
            stopColor='#F5FF43'
          />
          <stop
            offset={0.618}
            stopColor='#82E82D'
          />
          <stop
            offset={0.733}
            stopColor='#00C79F'
          />
          <stop
            offset={0.83}
            stopColor='#00CCEC'
          />
          <stop
            offset={0.958}
            stopColor='#69DBFF'
          />
        </linearGradient>
        <linearGradient
          id='j'
          x1={7.092}
          x2={61.76}
          y1={14.899}
          y2={26.4}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#812500' />
          <stop
            offset={0.158}
            stopColor='#B30056'
          />
          <stop
            offset={0.297}
            stopColor='#FF5945'
          />
          <stop
            offset={0.406}
            stopColor='#FFBD2D'
          />
          <stop
            offset={0.533}
            stopColor='#F5FF43'
          />
          <stop
            offset={0.618}
            stopColor='#82E82D'
          />
          <stop
            offset={0.733}
            stopColor='#00C79F'
          />
          <stop
            offset={0.83}
            stopColor='#00CCEC'
          />
          <stop
            offset={0.958}
            stopColor='#69DBFF'
          />
        </linearGradient>
        <linearGradient
          id='k'
          x1={8.206}
          x2={62.874}
          y1={9.603}
          y2={21.104}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#812500' />
          <stop
            offset={0.158}
            stopColor='#B30056'
          />
          <stop
            offset={0.297}
            stopColor='#FF5945'
          />
          <stop
            offset={0.406}
            stopColor='#FFBD2D'
          />
          <stop
            offset={0.533}
            stopColor='#F5FF43'
          />
          <stop
            offset={0.618}
            stopColor='#82E82D'
          />
          <stop
            offset={0.733}
            stopColor='#00C79F'
          />
          <stop
            offset={0.83}
            stopColor='#00CCEC'
          />
          <stop
            offset={0.958}
            stopColor='#69DBFF'
          />
        </linearGradient>
        <linearGradient
          id='l'
          x1={8.755}
          x2={63.424}
          y1={6.992}
          y2={18.493}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#812500' />
          <stop
            offset={0.158}
            stopColor='#B30056'
          />
          <stop
            offset={0.297}
            stopColor='#FF5945'
          />
          <stop
            offset={0.406}
            stopColor='#FFBD2D'
          />
          <stop
            offset={0.533}
            stopColor='#F5FF43'
          />
          <stop
            offset={0.618}
            stopColor='#82E82D'
          />
          <stop
            offset={0.733}
            stopColor='#00C79F'
          />
          <stop
            offset={0.83}
            stopColor='#00CCEC'
          />
          <stop
            offset={0.958}
            stopColor='#69DBFF'
          />
        </linearGradient>
        <linearGradient
          id='m'
          x1={8.63}
          x2={63.297}
          y1={7.591}
          y2={19.091}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#812500' />
          <stop
            offset={0.158}
            stopColor='#B30056'
          />
          <stop
            offset={0.297}
            stopColor='#FF5945'
          />
          <stop
            offset={0.406}
            stopColor='#FFBD2D'
          />
          <stop
            offset={0.533}
            stopColor='#F5FF43'
          />
          <stop
            offset={0.618}
            stopColor='#82E82D'
          />
          <stop
            offset={0.733}
            stopColor='#00C79F'
          />
          <stop
            offset={0.83}
            stopColor='#00CCEC'
          />
          <stop
            offset={0.958}
            stopColor='#69DBFF'
          />
        </linearGradient>
        <clipPath id='a'>
          <path
            fill='#fff'
            d='M0 0h60.686v24H0z'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
